/**
 * «Por completar»: lo que la IA dejó empezado al crear el sitio.
 *
 * Va donde va el estado de una oferta —en las listas, en el Resumen, en el
 * lienzo— y en lugar del selector de publicar: una oferta así no se puede
 * publicar hasta pasar por su asistente, así que ofrecer «Publicar» sólo
 * llevaría a un error. Pulsarla abre ese asistente.
 */
import { IconSparkles } from '@tabler/icons-react'
import { VelticaMascot } from '@webbuilder/ui'
import { useI18n } from '../../../lib/i18n'

export function AiPendingChip({ onComplete, compact = false }: { onComplete: () => void; compact?: boolean }) {
  const { t } = useI18n()
  return (
    <button
      type="button"
      className={`dash-ai-pending-chip${compact ? ' is-compact' : ''}`}
      title={t('aiPending.chipHint')}
      aria-label={t('aiPending.chipAria')}
      onClick={(event) => { event.stopPropagation(); onComplete() }}
    >
      <VelticaMascot outline size={15} />
      <span>{t('aiPending.chip')}</span>
    </button>
  )
}
